export default {
    Default: "#434242",
    Urgent: "#E66C6C",
    Priority: "#EDAA4F",
    Routine: "#6C87C6",
}
